import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { currentLocale } from '@/i18n';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8080/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Instance pour Sanctum (sans /api) - Dynamique
const sanctumApi = axios.create({
  baseURL: (import.meta.env.VITE_API_URL || 'http://localhost:8080/api').replace('/api', ''),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Intercepteur pour ajouter le token + locale (messages API i18n backend)
api.interceptors.request.use((config) => {
  const authStore = useAuthStore();
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }
  config.headers['Accept-Language'] = currentLocale?.value || 'en';
  return config;
});

// Intercepteur pour gérer les erreurs 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const authStore = useAuthStore();
      authStore.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { sanctumApi };
export default api;